<template> 
    <div>
      <div class="nav_bar">
          <nav-top-bar></nav-top-bar>
      </div>
      <div class="clear"></div>
        <!-- <side-bar></side-bar> -->
        <div class="main-container">
          <router-view></router-view>
        </div>
        <footer-content></footer-content>
    </div>
    
</template>

<script>
import NavTopBar from "@/components/NavTopBar.vue";
import SideBar from "@/components/SideBar.vue";
import BreadcrumbWly from "@/components/BreadcrumbWly.vue";
import FooterContent from "@/components/Footer.vue";
export default {
  name: "NavBar",
  components: {
    NavTopBar,
    SideBar,
    BreadcrumbWly,
    FooterContent
  }
};
</script>



// WEBPACK FOOTER //
// src/components/NavBar.vue